import { render } from "./board_info.vue?vue&type=template&id=cc96467e"
import script from "./board_info.vue?vue&type=script&lang=js"
export * from "./board_info.vue?vue&type=script&lang=js"

import "./board_info.vue?vue&type=style&index=0&id=cc96467e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__